module.exports = __webpack_public_path__ + "static/media/car-loader.4d40e7ba.gif";